// Generated by purs version 0.14.3
"use strict";
var $foreign = require("./foreign.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Error = require("../Data.Argonaut.Decode.Error/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_ByteString = require("../Data.ByteString/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Show_Generic = require("../Data.Show.Generic/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Foreign = require("../Foreign/index.js");
var Foreign_Generic_Class = require("../Foreign.Generic.Class/index.js");
var Network_Ethereum_Core_HexString = require("../Network.Ethereum.Core.HexString/index.js");
var Network_Ethereum_Core_Keccak256 = require("../Network.Ethereum.Core.Keccak256/index.js");
var Node_Encoding = require("../Node.Encoding/index.js");
var Simple_JSON = require("../Simple.JSON/index.js");
var Type_Quotient = require("../Type.Quotient/index.js");
var Signature = function (x) {
    return x;
};
var PublicKey = function (x) {
    return x;
};
var PrivateKey = function (x) {
    return x;
};
var ChainId = function (x) {
    return x;
};
var Address = function (x) {
    return x;
};
var unPublicKey = function (v) {
    return Network_Ethereum_Core_HexString.fromByteString(v);
};
var unPrivateKey = function (v) {
    return Network_Ethereum_Core_HexString.fromByteString(v);
};
var unAddress = function (v) {
    return v;
};
var toEthSignedMessage = function (bs) {
    var x19 = Data_ByteString.singleton(Type_Quotient.mkQuotient(25));
    return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_ByteString.fromString("Ethereum Signed Message:\x0a")(Node_Encoding.UTF8.value))(function (pfx) {
        return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_ByteString.fromString(Data_Show.show(Data_Show.showInt)(Data_ByteString.length(bs)))(Node_Encoding.UTF8.value))(function (lenStr) {
            return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(Data_Semigroup.append(Data_ByteString.semigroupByteString)(x19)(Data_Semigroup.append(Data_ByteString.semigroupByteString)(pfx)(Data_Semigroup.append(Data_ByteString.semigroupByteString)(lenStr)(bs))));
        });
    });
};
var signMessage = function (privateKey) {
    return function (message) {
        var v = $foreign.ecSign(privateKey, message);
        return {
            r: Network_Ethereum_Core_HexString.fromByteString(v.r),
            s: Network_Ethereum_Core_HexString.fromByteString(v.s),
            v: v.v
        };
    };
};
var showPublicKey = new Data_Show.Show(function (v) {
    return Data_Show.show(Network_Ethereum_Core_HexString.showHexString)(Network_Ethereum_Core_HexString.fromByteString(v));
});
var showPrivateKey = new Data_Show.Show(function (v) {
    return Data_Show.show(Network_Ethereum_Core_HexString.showHexString)(Network_Ethereum_Core_HexString.fromByteString(v));
});
var removeChainIdOffset = function (v) {
    return function (v1) {
        return {
            r: v1.r,
            s: v1.s,
            v: (v1.v - 35 | 0) - (2 * v | 0) | 0
        };
    };
};
var recoverSender = function (messageHash) {
    return function (v) {
        return $foreign.ecRecover(messageHash, Data_Semigroup.append(Data_ByteString.semigroupByteString)(Network_Ethereum_Core_HexString.toByteString(v.r))(Network_Ethereum_Core_HexString.toByteString(v.s)), v.v);
    };
};
var nullAddress = Address(Network_Ethereum_Core_HexString.takeHex(40)(Network_Ethereum_Core_HexString.nullWord));
var mkPublicKey = function (publicKey) {
    var publicKeyBS = Network_Ethereum_Core_HexString.toByteString(publicKey);
    var $52 = $foreign.isValidPublic(publicKeyBS);
    if ($52) {
        return Data_Maybe.Just.create(publicKeyBS);
    };
    return Data_Maybe.Nothing.value;
};
var mkPrivateKey = function (privateKey) {
    var privateKeyBS = Network_Ethereum_Core_HexString.toByteString(privateKey);
    var $53 = $foreign.isValidPrivate(privateKeyBS);
    if ($53) {
        return Data_Maybe.Just.create(privateKeyBS);
    };
    return Data_Maybe.Nothing.value;
};
var mkAddress = function (hx) {
    var $54 = Network_Ethereum_Core_HexString.hexLength(hx) === 40;
    if ($54) {
        return Data_Maybe.Just.create(Address(hx));
    };
    return Data_Maybe.Nothing.value;
};
var publicToAddress = function (v) {
    var addrHex = Network_Ethereum_Core_HexString.fromByteString(Network_Ethereum_Core_Keccak256.keccak256(Network_Ethereum_Core_Keccak256.keccak256ByteString)(v));
    return Data_Maybe.fromJust()(mkAddress(Network_Ethereum_Core_HexString.dropHex(24)(addrHex)));
};
var privateToAddress = function ($72) {
    return publicToAddress($foreign.privateToPublic($72));
};
var genericSignature = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showSignature = new Data_Show.Show(Data_Show_Generic.genericShow(genericSignature)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "r";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "s";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "v";
}))(Data_Show.showRecordFieldsNil)(Data_Show.showInt))(Network_Ethereum_Core_HexString.showHexString))(Network_Ethereum_Core_HexString.showHexString))))(new Data_Symbol.IsSymbol(function () {
    return "Signature";
}))));
var genericChainId = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showChainId = new Data_Show.Show(Data_Show_Generic.genericShow(genericChainId)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))(new Data_Symbol.IsSymbol(function () {
    return "ChainId";
}))));
var eqSignature = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.r)(y.r) && Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.s)(y.s) && x.v === y.v;
    };
});
var eqPublicKey = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Data_ByteString.eqByteString)(x)(y);
    };
});
var eqPrivateKey = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Data_ByteString.eqByteString)(x)(y);
    };
});
var eqChainId = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x === y;
    };
});
var encodeJsonAddress = new Data_Argonaut_Encode_Class.EncodeJson((function () {
    var $73 = Data_Argonaut_Encode_Class.encodeJson(Network_Ethereum_Core_HexString.encodeJsonHexString);
    return function ($74) {
        return $73(unAddress($74));
    };
})());
var encodeAddress = Network_Ethereum_Core_HexString.encodeHexString;
var writeFAddress = new Simple_JSON.WriteForeign(Foreign_Generic_Class.encode(encodeAddress));
var addressShow = Network_Ethereum_Core_HexString.showHexString;
var addressOrd = Network_Ethereum_Core_HexString.hexStringOrd;
var addressEq = Network_Ethereum_Core_HexString.hexStringEq;
var addChainIdOffset = function (v) {
    return function (v1) {
        return {
            r: v1.r,
            s: v1.s,
            v: (v1.v + 35 | 0) + (2 * v | 0) | 0
        };
    };
};
var _decode = function (hx) {
    var v = mkAddress(hx);
    if (v instanceof Data_Maybe.Nothing) {
        return Data_Either.Left.create("Address must be 20 bytes long: " + Data_Show.show(Network_Ethereum_Core_HexString.showHexString)(hx));
    };
    if (v instanceof Data_Maybe.Just) {
        return new Data_Either.Right(v.value0);
    };
    throw new Error("Failed pattern match at Network.Ethereum.Core.Signatures (line 116, column 14 - line 118, column 24): " + [ v.constructor.name ]);
};
var decodeAddress = new Foreign_Generic_Class.Decode(function (a) {
    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(Network_Ethereum_Core_HexString.decodeHexString)(a))(function (hxString) {
        return Data_Either.either((function () {
            var $75 = Foreign.fail(Data_Identity.monadIdentity);
            return function ($76) {
                return $75(Foreign.ForeignError.create($76));
            };
        })())(Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity)))(_decode(hxString));
    });
});
var readFAddress = new Simple_JSON.ReadForeign(Foreign_Generic_Class.decode(decodeAddress));
var decodeJsonAddress = new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Network_Ethereum_Core_HexString.decodeJsonHexString)(json))(function (hxString) {
        return Data_Either.either(Data_Function["const"](Data_Either.Left.create(new Data_Argonaut_Decode_Error.UnexpectedValue(json))))(Data_Either.Right.create)(_decode(hxString));
    });
});
module.exports = {
    unPublicKey: unPublicKey,
    mkPublicKey: mkPublicKey,
    unPrivateKey: unPrivateKey,
    mkPrivateKey: mkPrivateKey,
    unAddress: unAddress,
    mkAddress: mkAddress,
    nullAddress: nullAddress,
    privateToAddress: privateToAddress,
    publicToAddress: publicToAddress,
    Signature: Signature,
    signMessage: signMessage,
    toEthSignedMessage: toEthSignedMessage,
    recoverSender: recoverSender,
    ChainId: ChainId,
    addChainIdOffset: addChainIdOffset,
    removeChainIdOffset: removeChainIdOffset,
    showPrivateKey: showPrivateKey,
    eqPrivateKey: eqPrivateKey,
    showPublicKey: showPublicKey,
    eqPublicKey: eqPublicKey,
    addressShow: addressShow,
    addressEq: addressEq,
    addressOrd: addressOrd,
    encodeAddress: encodeAddress,
    decodeAddress: decodeAddress,
    decodeJsonAddress: decodeJsonAddress,
    encodeJsonAddress: encodeJsonAddress,
    readFAddress: readFAddress,
    writeFAddress: writeFAddress,
    genericSignature: genericSignature,
    eqSignature: eqSignature,
    showSignature: showSignature,
    genericChainId: genericChainId,
    eqChainId: eqChainId,
    showChainId: showChainId,
    generatePrivateKey: $foreign.generatePrivateKey,
    privateToPublic: $foreign.privateToPublic
};
